// extracted by mini-css-extract-plugin
module.exports = {"power-backup-L":"L_power-backup-L__38W9Y"};